(() => {
  function initialise(root) {
    if (root.dataset.aeReady) return;
    root.dataset.aeReady = 'true';
    const prose = root.querySelector('[data-ae-prose]');
    if (!prose) return;
    const readingTools = root.querySelector('.ae-reading-tools');
    prose.querySelectorAll('table').forEach(table => {
      if (table.parentElement.classList.contains('ae-table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'ae-table-scroll';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || root.dataset.tableLabel);
      table.before(wrapper);
      wrapper.append(table);
    });
    const toc = root.querySelector('[data-ae-toc]');
    const list = root.querySelector('[data-ae-toc-list]');
    if (toc && list) {
      const headings = [...prose.querySelectorAll('h2')].filter(h => h.textContent.trim());
      headings.forEach((heading, i) => {
        if (!heading.id || document.getElementById(heading.id) !== heading) {
          let id = `${root.id}-section-${i + 1}`;
          while (document.getElementById(id)) id += '-a';
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      if (headings.length > 1) {
        toc.hidden = false;
        const wide = matchMedia('(min-width: 1024px)');
        toc.open = wide.matches;
        wide.addEventListener('change', () => { toc.open = wide.matches; });
      }
    }
    let start = 0, distance = 1, pending = false;
    const paint = () => {
      pending = false;
      if (!root.isConnected) return;
      const value = Math.min(1, Math.max(0, (scrollY - start) / distance));
      root.style.setProperty('--ae-progress', value.toFixed(4));
    };
    const schedule = () => {
      if (!pending) { pending = true; requestAnimationFrame(paint); }
    };
    const measure = () => {
      if (readingTools) {
        const toolsHeight = readingTools.getBoundingClientRect().height;
        if (toolsHeight > 0) readingTools.style.setProperty('--ae-tools-height', `${Math.ceil(toolsHeight)}px`);
      }
      const rect = prose.getBoundingClientRect();
      start = rect.top + scrollY - innerHeight * 0.2;
      distance = Math.max(1, rect.height - innerHeight * 0.6);
      schedule();
    };
    let measuring = false;
    const queueMeasure = () => {
      if (!measuring) requestAnimationFrame(() => { measuring = false; measure(); });
      measuring = true;
    };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', queueMeasure, { passive: true });
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(queueMeasure);
      observer.observe(prose);
      if (readingTools) observer.observe(readingTools);
    }
    document.fonts?.ready.then(queueMeasure);
    toc?.addEventListener('toggle', queueMeasure);
    measure();
    const copy = root.querySelector('[data-ae-copy]');
    if (copy) {
      copy.hidden = false;
      copy.addEventListener('click', async () => {
        const status = root.querySelector('[data-ae-copy-status]');
        try {
          await navigator.clipboard.writeText(copy.dataset.copyUrl);
          status.textContent = copy.dataset.copied;
        } catch {
          const fallback = root.querySelector('[data-ae-copy-fallback]');
          status.textContent = copy.dataset.copyFailed;
          if (fallback) { fallback.hidden = false; fallback.focus(); fallback.select(); }
        }
      });
    }
  }
  document.querySelectorAll('[data-ae-article]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-ae-article]').forEach(initialise);
  });
  document.addEventListener('change', event => {
    const select = event.target.closest?.('[data-ae-page-size]');
    if (!select || !['', 'ace-news-40', 'ace-news-60', 'ace-news-80', 'ace-news-100'].includes(select.value)) return;
    const url = new URL(location.href);
    url.searchParams.delete('page');
    if (select.value) url.searchParams.set('view', select.value);
    else url.searchParams.delete('view');
    url.hash = 'news-results';
    location.assign(url.href);
  });
})();

(() => {
  function enhanceNews(scope) {
    scope.querySelectorAll('[data-ae-news]').forEach(root => root.classList.add('ae-enhanced'));
    scope.querySelectorAll('.ae-topic-bar').forEach(bar => {
    if (bar.dataset.aeReady) return;
    bar.dataset.aeReady = 'true';
    const nav=bar.querySelector('.ae-topics');
    const prev=bar.querySelector('[data-ae-topics-prev]');
    const next=bar.querySelector('[data-ae-topics-next]');
    if(!nav || !prev || !next) return;
    const reducedMotion=matchMedia('(prefers-reduced-motion:reduce)');
    let pauseUntil=0;
    const update=()=>{const overflow=nav.scrollWidth>nav.clientWidth+2; prev.hidden=next.hidden=!overflow;prev.disabled=nav.scrollLeft<=1;next.disabled=nav.scrollLeft+nav.clientWidth>=nav.scrollWidth-2;};
    const move=direction=>nav.scrollBy({left:direction*Math.max(180,nav.clientWidth*0.7),behavior:reducedMotion.matches?'auto':'smooth'});
    prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
    const pause=()=>{pauseUntil=Date.now()+8000;};
    bar.addEventListener('pointerdown',pause,{passive:true});
    bar.addEventListener('wheel',pause,{passive:true});
    bar.addEventListener('keydown',pause);
    nav.addEventListener('scroll',update,{passive:true});
    const observer='ResizeObserver' in window?new ResizeObserver(update):null;
    if(observer)observer.observe(nav);else addEventListener('resize',update,{passive:true});
    const timer=setInterval(()=>{
      if(!bar.isConnected){clearInterval(timer);observer?.disconnect();return;}
      if(document.visibilityState!=='visible'||Date.now()<pauseUntil||bar.matches(':focus-within')||(matchMedia('(hover:hover)').matches&&bar.matches(':hover')))return;
      const rect=bar.getBoundingClientRect();
      if(rect.bottom<=0||rect.top>=innerHeight||nav.scrollWidth<=nav.clientWidth+2)return;
      if(nav.scrollLeft+nav.clientWidth>=nav.scrollWidth-2)nav.scrollTo({left:0,behavior:reducedMotion.matches?'auto':'smooth'});
      else move(1);
    },5000);
    bar.addEventListener('ae:disconnect',()=>{clearInterval(timer);observer?.disconnect();},{once:true});
    update();
    });
  }
  enhanceNews(document);
  document.addEventListener('shopify:section:load',event=>enhanceNews(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.ae-topic-bar').forEach(bar=>bar.dispatchEvent(new Event('ae:disconnect'))));
})();
